import React from 'react';
import ModalViewer from '@components/Modal/ModalViewer';
import { makeStyles, Typography } from '@material-ui/core';
import { ModalValues } from '@interfaces/ModalValues';
import { ScheduleColumnData } from '@data/schedules/types/ScheduleColumnData';
import { BlockReleaseRequestConfirmModalInfo } from '@components/BlockRelease/BlockReleaseRequest/BlockReleaseRequestConfirmModal/BlockReleaseRequestConfirmModalInfo/BlockReleaseRequestConfirmModalInfo';
import { BlockReleaseRequestConfirmModalButtons } from '@components/BlockRelease/BlockReleaseRequest/BlockReleaseRequestConfirmModal/BlockReleaseRequestConfirmModalButtons/BlockReleaseRequestConfirmModalButtons';
import { Facility } from '@interfaces/Facility';
import { BlockReleaseTransformedResponse } from '@data/blockReleases/types/BlockRelease.types';

export interface BlockReleaseConfirmModalProps {
	modalValues: ModalValues;
	blockReleaseInfo: ScheduleColumnData;
	facilityInfo: Facility;
	selectedRelease: BlockReleaseTransformedResponse;
}

const useStyles = makeStyles((theme) => ({
	title: {
		marginBottom: theme.spacing(3),
	},
}));

export const BlockReleaseRequestConfirmModal: React.FC<BlockReleaseConfirmModalProps> = ({
	modalValues,
	facilityInfo,
	blockReleaseInfo,
	selectedRelease,
}) => {
	const classes = useStyles();

	return (
		<ModalViewer
			dataField="blockRelease-blockReleaseRequestModal"
			id={modalValues.id+selectedRelease?.slotId}
		>
			<Typography component="h2" variant="h6" className={classes.title}>
				{modalValues.title}
			</Typography>
			<BlockReleaseRequestConfirmModalInfo
				modalValues={modalValues}
				blockReleaseInfo={blockReleaseInfo}
				facilityInfo={facilityInfo}
				selectedRelease={selectedRelease}
			/>
			<BlockReleaseRequestConfirmModalButtons
				facilityInfo={facilityInfo}
				selectedRelease={selectedRelease}
			/>
		</ModalViewer>
	);
};
